
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class TradeMacroAssignmentDialog extends SiteEntityDialog<TradeMacroAssignmentRow, any> {
        protected getFormKey() { return TradeMacroAssignmentForm.formKey; }
        protected getIdProperty() { return TradeMacroAssignmentRow.idProperty; }
        protected getLocalTextPrefix() { return TradeMacroAssignmentRow.localTextPrefix; }
        protected getNameProperty() { return TradeMacroAssignmentRow.nameProperty; }
        protected getService() { return TradeMacroAssignmentService.baseUrl; }

        protected form = new TradeMacroAssignmentForm(this.idPrefix);

    }
}